import BalanceSheet from '@/components/BalanceSheet.vue'
import Documents from '@/components/Documents.vue'
import GeneralJournal from '@/components/GeneralJournal.vue'
import IncomeStatement from '@/components/IncomeStatement.vue'
import VatReports from '@/components/VatReports.vue'
import { service } from '@/core/constants'
import { ROUTE_NAME } from '@/router/meta'
import ReportsView from '@/views/Reports.vue'
import type { RouteRecordRaw } from 'vue-router'

const vatReportsRoute: RouteRecordRaw = {
  path: 'vat-report',
  name: 'vat_reports',
  component: VatReports,
  meta: {
    icon: '$percent-outline',
    requiresAuth: true,
    [ROUTE_NAME]: 'vat_reports'
  }
}

const generalJournalRoute: RouteRecordRaw = {
  path: 'general-journal',
  name: 'general_journal',
  component: GeneralJournal,
  meta: {
    icon: '$file-outline',
    requiresAuth: true,
    [ROUTE_NAME]: 'general_journal'
  }
}

const incomeStatementRoute: RouteRecordRaw = {
  path: 'income-statement',
  name: 'income_statement',
  component: IncomeStatement,
  meta: {
    icon: '$calendar-blank-outline',
    requiresAuth: true,
    [ROUTE_NAME]: 'income_statement'
  }
}

const balanceSheetRoute: RouteRecordRaw = {
  path: 'balance-sheet',
  name: 'balance_sheet',
  component: BalanceSheet,
  meta: {
    icon: '$calendar-blank-outline',
    requiresAuth: true,
    [ROUTE_NAME]: 'balance_sheet'
  }
}

const documentsRoute: RouteRecordRaw = {
  path: 'report-documents',
  name: 'report-documents',
  component: Documents,
  meta: {
    requiresAuth: true,
    [ROUTE_NAME]: 'report-documents'
  }
}

export const setupReportRoutes = (): RouteRecordRaw[] => {
  const children: RouteRecordRaw[] = [
    vatReportsRoute,
    generalJournalRoute,
    incomeStatementRoute
  ]

  if (process.env.VUE_APP_SERVICE === service.OY) {
    children.push(balanceSheetRoute, documentsRoute)
  }

  return [
    {
      path: '/reports',
      name: 'reports',
      redirect: '/reports/vat-report',
      component: ReportsView,
      meta: {
        requiresAuth: true,
        showInMainNav: true,
        icon: '$file-document-outline',
        [ROUTE_NAME]: 'reports'
      },
      children
    }
  ]
}
